export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";
export const SET_MY_INFO = "SET_MY_INFO";
export const DESTROY_ACCESS_TOKEN = "DESTROY_ACCESS_TOKEN";
export const DESTROY_MY_INFO = "DESTROY_MY_INFO";
export const SET_KAKAOINFO = "SET_KAKAOINFO";
export const SET_HOSPITAL = "SET_HOSPITAL";
export const SET_CERTIFY_CARD = "SET_CERTIFY_CARD";
export const SET_CERTIFY_USER = "SET_CERTIFY_USER";

